import { render, staticRenderFns } from "./ModattaSideModal.vue?vue&type=template&id=027f1ba8"
import script from "./ModattaSideModal.vue?vue&type=script&lang=js"
export * from "./ModattaSideModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports